/* <atl-journey>: tracks scrolling through the four clay-to-ring stages, highlights the active
   stage and tells the 3D ring (atl-guide-ring.js) how far along it is via 'atl-journey:progress'. */
(function () {
  'use strict';

  if (customElements.get('atl-journey')) return;

  class AtlJourney extends HTMLElement {
    connectedCallback() {
      this.panels = Array.prototype.slice.call(this.querySelectorAll('.journey__panel'));
      this.label = this.querySelector('[data-journey-label]');
      this.stage = -1;
      var self = this, ticking = false;
      this.onScroll = function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () { ticking = false; self.update(); });
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll);
      // In the guide the journey sits in a chapter that can be shown or hidden.
      window.addEventListener('atl-guide:chapter', this.onScroll);
      this.update();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      window.removeEventListener('atl-guide:chapter', this.onScroll);
    }

    update() {
      if (!this.panels.length || this.offsetParent === null) return;
      var first = this.panels[0].getBoundingClientRect();
      var last = this.panels[this.panels.length - 1].getBoundingClientRect();
      var mid = window.innerHeight * 0.5;
      var start = first.top + first.height / 2;
      var span = (last.top + last.height / 2) - start;
      var p = span > 0 ? (mid - start) / span : 0;
      p = Math.min(Math.max(p, 0), 1);

      var stage = Math.min(this.panels.length - 1, Math.max(0, Math.round(p * (this.panels.length - 1))));
      if (stage !== this.stage) {
        this.stage = stage;
        this.panels.forEach(function (el, n) { el.classList.toggle('is-active', n === stage); });
        this.querySelectorAll('[data-index]').forEach(function (el) {
          el.classList.toggle('is-active', parseInt(el.dataset.index, 10) === stage);
        });
        this.dataset.stage = stage;
        if (this.label) this.label.textContent = this.panels[stage].dataset.stageLabel;
      }
      window.dispatchEvent(new CustomEvent('atl-journey:progress', { detail: { progress: p } }));
    }
  }

  customElements.define('atl-journey', AtlJourney);
})();
